import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api, { login } from '../api';

export default function InvitacionPage({ onAccepted }) {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [preview, setPreview] = useState(null);
  const [nombre, setNombre] = useState('');
  const [password, setPassword] = useState('');
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) return;
    api
      .get('/gastos-comunes/invitaciones/preview', { params: { token } })
      .then((r) => setPreview(r.data))
      .catch((e) => setError(e.response?.data?.error || e.message));
  }, [token]);

  const acceptNew = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await api.post('/gastos-comunes/invitaciones/aceptar', { token, nombre, password });
      setDone(true);
      if (onAccepted) onAccepted();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  const acceptWithLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(loginEmail, loginPassword);
      await api.post('/gastos-comunes/invitaciones/aceptar', { token });
      setDone(true);
      if (onAccepted) onAccepted();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  if (!token) {
    return (
      <div className="login-wrap">
        <div className="login-card">
          <p>Enlace de invitación incompleto.</p>
          <Link to="/login">Ir al login</Link>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div className="login-wrap">
        <div className="login-card">
          <div className="login-brand">
            <h1>Listo</h1>
            <p>Tu acceso fue activado.</p>
          </div>
          <Link to="/login" className="btn btn-block" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
            Entrar
          </Link>

        </div>
      </div>
    );
  }

  return (
    <div className="login-wrap">
      <div className="login-card" style={{ maxWidth: 440 }}>
        <div className="login-brand">
          <h1>Invitación</h1>
          {preview && (
            <p>
              {preview.condominio?.nombre} · {preview.email}
            </p>
          )}
        </div>
        {error && <div className="alert alert-error">{error}</div>}

        <p className="login-section-title">Cuenta nueva</p>
        <form onSubmit={acceptNew}>
          <div className="field">
            <label>Nombre</label>
            <input value={nombre} onChange={(e) => setNombre(e.target.value)} required />
          </div>
          <div className="field">
            <label>Contraseña (mín. 6)</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} />
          </div>
          <button type="submit" className="btn btn-block">
            Crear cuenta y aceptar
          </button>
        </form>

        <hr className="login-divider" />

        <p className="login-section-title">Ya tengo cuenta</p>
        <form onSubmit={acceptWithLogin}>
          <div className="field">
            <label>Correo</label>
            <input type="email" value={loginEmail} onChange={(e) => setLoginEmail(e.target.value)} required />
          </div>
          <div className="field">
            <label>Contraseña</label>
            <input type="password" value={loginPassword} onChange={(e) => setLoginPassword(e.target.value)} required />
          </div>
          <button type="submit" className="btn secondary btn-block">
            Iniciar sesión y aceptar
          </button>
        </form>
      </div>
    </div>
  );
}
